import Login from "../views/login.vue";
import PasswordRecovery from "../views/passwordRecovery.vue";
import Register from "../views/registerAgent.vue";
import Support from "../views/helpDesctop/supportMain.vue";


const menu = [
  { title: "Тех. поддержка", icon: "fas fa-question-circle", url: "/support", id: 99 },
  { title: "Выход", icon: "fas fa-sign-out-alt", url: "/logout", id: 100 }
];

const routes = [
  {
    path: "/support",
    name: "support",
    component: Support,
    meta: {
      forAuth: true
    }
  },
  {
    path: "/",
    component: Login,
    meta: {
      forVisitors: true
    }
  },

  {
    path: "/login",
    component: Login,
    meta: {
      forVisitors: true
    }
  },
  {
    path: "/passwordrecovery",
    component: PasswordRecovery,
    meta: {
      forVisitors: true
    }
  },

  {
    path: "/register",
    component: Register,
    meta: {
      forVisitors: true
    }
  },
  {
    path: "/logout",
    component: Login,
    meta: {
      forVisitors: true
    }
  }
];

export default { menu, routes };
